/* eslint-disable consistent-return */
import { useEffect } from 'react';
import useIsMobile from './use-is-mobile';

/**
 * Custom hook to block/unblock page scrolling on mobile devices
 * @param {boolean} shouldBlock - Whether scrolling should be blocked
 */
const useScrollBlock = shouldBlock => {
  const { isMobile } = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    if (shouldBlock) {
      // Block scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling
      const scrollY = document.body.style.top;
      document.body.style.overflow = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }

    // Cleanup function to restore scrolling if component unmounts while blocked
    return () => {
      if (shouldBlock && isMobile) {
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    };
  }, [shouldBlock, isMobile]);
};

export default useScrollBlock;
